import * as React from "react";
const View = require("../../views/Landing/landingpagemain.view");
const ArrayLandingPageMain = require("../Landing/ArrayLandingPageMain");

import {
  checkEmail,
  checkPhone,
  checkNameAdminDemandeContact,
  checkNameEtablissement,
  checkMultiple
} from "../../utils/CheckUtils";
import { isNullOrUndefined } from "util";
import * as Utils from "../../utils/Utils";
import ModalLandingPageRessources from "./ModalLandingPageRessources.component";
const ObjectifsLivreBlanc = require("./ObjectifsLivreBlanc2");

declare var window;
declare var userId;
declare var adminId;
declare var document;
interface IStateLandingPageMain {
  userCards: {
    url: string;
    text: string;
    whichSize: string;
  }[];
  ObjectifsLivreBlanc: { title: string; description: string }[];
  etablissementName: string;
  name: string;
  mobilePhone: string;
  email: string;
  modalShowContact: boolean;
  modalShowLivreBlanc: boolean;
  errorMessage: string;
  isLoading: boolean;
}
class LandingPageMain extends React.Component {
  state: IStateLandingPageMain;
  constructor(props) {
    super(props);

    this.state = {
      userCards: ArrayLandingPageMain,
      ObjectifsLivreBlanc: ObjectifsLivreBlanc,
      etablissementName: "",
      name: "",
      mobilePhone: "",
      email: "",
      modalShowContact: false,
      errorMessage: "",
      isLoading: false,
      modalShowLivreBlanc: false
    };
  }
  onChange(key: string, value: string): void {
    this.setState({
      [key]: value,
      errorMessage: ""
    });
  }

  render() {
    return (
      <View
        ModalLandingPageRessources={
          <ModalLandingPageRessources
            onHide={this.onHideLivreBlanc.bind(this)}
            show={this.state.modalShowLivreBlanc}
          />
        }
        userCards={this.state.userCards}
        ObjectifsLivreBlanc={this.state.ObjectifsLivreBlanc}
        nextPageContact={this.nextPageContact.bind(this)}
        nextPageLivreBlanc={this.nextPageLivreBlanc.bind(this)}
        nextPageConnect={this.nextPageConnect.bind(this)}
        etablissementName={this.state.etablissementName}
        name={this.state.name}
        mobilePhone={this.state.mobilePhone}
        email={this.state.email}
        modalShowContact={this.state.modalShowContact}
        onChange={this.onChange.bind(this)}
        onHideContact={this.onHideContact.bind(this)}
        errorMessage={this.state.errorMessage}
        isLoading={this.state.isLoading}
        nextPageToContact={this.nextPageToContact.bind(this)}
        nextPageMedgo={this.nextPageMedgo.bind(this)}
      />
    );
  }

  nextPageContact() {
    let email = this.state.email.trim();
    let name = this.state.name;
    let etablissementName = this.state.etablissementName;
    let mobilePhone = this.state.mobilePhone;

    let checks = [];
    checks.push(checkNameEtablissement(etablissementName));
    checks.push(checkNameAdminDemandeContact(name));
    checks.push(checkPhone(mobilePhone));
    checks.push(checkEmail(email));

    let { errorMessage } = checkMultiple(checks);

    if (!isNullOrUndefined(errorMessage)) {
      this.setState({
        errorMessage: errorMessage
      });
      return;
    }

    this.update({
      email: email,
      mobilePhone: mobilePhone,
      etablissementName: etablissementName,
      name: name
    });
  }

  nextPageToContact() {
    let element = document.getElementById("contact");

    element.scrollIntoView({ behavior: "smooth" });
  }
  onHideContact() {
    this.setState({ modalShowContact: false });
  }
  onHideLivreBlanc() {
    this.setState({ modalShowLivreBlanc: false });
  }

  async update(_data) {
    this.setState({ isLoading: true });
    try {
      let postData = {
        email: _data.email,
        nameClient: _data.etablissementName,
        nameAdmin: _data.name,
        phone: _data.mobilePhone
      };
      let data = await Utils.request("/clientSignUp/create", "POST", postData);
      this.setState({ modalShowContact: true, isLoading: false, errorMessage: "" });
    } catch (err) {
      console.error(err);
      if (err.responseText) {
        this.setState({
          errorMessage: err.responseText,
          isLoading: false
        });
      } else {
        this.setState({
          errorMessage: err,
          isLoading: false
        });
      }
    }
  }

  nextPageMedgo() {
    window.open("https://www.medgo.fr");
  }

  nextPageConnect() {
    window.location = "/loginadmin";
  }

  nextPageLivreBlanc() {
    this.setState({ modalShowLivreBlanc: true });
  }
}
export default LandingPageMain;



// WEBPACK FOOTER //
// ./assets/react/components/Landing/landingpagemain.component.tsx